// eslint-disable-next-line import/prefer-default-export
export const WINDOW_REDUX_KEY = '_REDUX_';
